// extracted by mini-css-extract-plugin
export default {"DropdownSelect":"DropdownSelect_DropdownSelect__04Cwc"};